import { ControllerRenderProps } from 'react-hook-form';

/**
 * Lets a FieldFactory input run on plain state instead of a react-hook-form field. The
 * select inputs call onBlur on focus out and pass ref to the text field, so both are given.
 */
export function controlledFormProps<T>(value: T, onChange: (value: T) => void): ControllerRenderProps {
  return {
    value,
    onChange,
    onBlur: () => {},
    ref: () => {},
    name: 'controlled',
  } as unknown as ControllerRenderProps;
}
